import { Injectable } from "@angular/core";
import { DataService } from "../DataService/data.service";
import { Observable } from "rxjs";
import { HttpParams } from "@angular/common/http";
import { APIName } from "../../Models/APIEndPoints/APIName";
import { IVendorCategory } from "src/app/Models/Interface/Vendor/vendor-catgory";
import { IPagination } from "src/app/Models/Interface/Pagination/pagination";
import { IBaseData } from "src/app/Models/Interface/Base/base-data";
import { IBaseVendorProduct } from "src/app/Models/Interface/Base/base-vendor-product";
import { IVendorProduct } from "src/app/Models/Interface/Vendor/vendor-product";
import { IProductVendorDetails } from "src/app/Models/Interface/Vendor/product-vendor-details";
import { IEditCost } from "src/app/Models/Interface/Vendor/edit-cost";
import { IChangeProductStatus } from "src/app/Models/Interface/Vendor/change-product-status";

@Injectable({
  providedIn: "root",
})
export class VendorProductService {
  categoryId: number = 0;
  vendorId: number = 0;
  pagination = {
    skip: 0,
    take: 15,
    pagesCount: 0,
    inPageNumber: 1,
    leftItems: 0,
  } as IPagination;
  keyword: string = "";
  isOutOfStock: string = "";
  editCostOBJ = {} as IEditCost;
  productStatus = {} as IChangeProductStatus;

  constructor(private dataService: DataService) {}

  getCategories(): Observable<IVendorCategory[]> {
    let params = new HttpParams();
    // @ts-ignore
    params = params.append("vendorId", this.vendorId);
    params = params.append("parentCategoryId", this.categoryId);
    return this.dataService.getWithParams(
      APIName.vendor.products.categoryList,
      params
    );
  }

  getProducts(): Observable<IBaseData<IBaseVendorProduct<IVendorProduct[]>>> {
    let params = new HttpParams();
    // @ts-ignore
    params = params.append("VendorId", this.vendorId);
    params = params.append("CategoryId", this.categoryId);
    params = params.append("Skip", this.pagination.skip);
    params = params.append("Take", this.pagination.take);
    params = params.append("Keyword", this.keyword);
    params = params.append("isOutOfStock", this.isOutOfStock);
    return this.dataService.getWithParams(
      APIName.vendor.products.products,
      params
    );
  }

  getProductDetails(id: number): Observable<IProductVendorDetails[]> {
    let params = new HttpParams();
    // @ts-ignore
    params = params.append("productVendorId", id);
    return this.dataService.getWithParams(
      APIName.vendor.products.productDetails,
      params
    );
  }

  editCost(): Observable<any> {
    return this.dataService.post(
      APIName.vendor.products.editCost,
      this.editCostOBJ
    );
  }

  changeStatus(): Observable<any> {
    return this.dataService.post(
      APIName.vendor.products.changeStatus,
      this.productStatus
    );
  }
}
